export default __webpack_public_path__ + "static/media/solenn_church.431d34fc.jpg";